document.addEventListener('DOMContentLoaded', function() {
  var cardWrappersNodeList = document.querySelectorAll('.show-profile-wrapper');
  var cardWrappers = Array.prototype.slice.call(cardWrappersNodeList); // Convert NodeList to Array

  cardWrappers.forEach(function(cardWrapper) {
    var cardContentPlaceholder = cardWrapper.querySelector('.card-content-placeholder');
    var showId = cardWrapper.getAttribute('data-show-id');
    cardWrapper.dataset.contentLoaded = 'false'; // Initialize contentLoaded as a data attribute

    // Set `inert` initially to prevent interaction when hidden
    cardContentPlaceholder.setAttribute('inert', '');

    // Load content on hover
    cardWrapper.addEventListener('mouseenter', function() {
      if (cardWrapper.dataset.contentLoaded === 'false') {
        var hiddenContent = document.getElementById('card-content-' + showId);
        if (hiddenContent) {
          cardContentPlaceholder.innerHTML = hiddenContent.innerHTML;

          // Remove any existing close icon to prevent duplicates
          var existingCloseIcon = cardContentPlaceholder.querySelector('.shows-close-icon');
          if (existingCloseIcon) {
            existingCloseIcon.remove();
          }

          // Add the close icon for mobile
          if (window.innerWidth <= 768) {
            var closeIcon = document.createElement('span');
            closeIcon.className = 'shows-close-icon';
            closeIcon.innerHTML = '&times;';
            closeIcon.style.position = 'absolute';
            closeIcon.style.top = '20px';
            closeIcon.style.right = '20px';
            closeIcon.style.fontSize = '24px';
            closeIcon.style.color = '#fff';
            closeIcon.style.cursor = 'pointer';
            closeIcon.style.zIndex = '99';
            
            // Pass the showId to showscloseCard
            closeIcon.onclick = function() {
              showscloseCard(showId);
            };

            cardContentPlaceholder.querySelector('.card').appendChild(closeIcon);
          }

          var card = cardContentPlaceholder.querySelector('.card');
          if (card) {
            card.classList.add('visible');
          }

          // Remove `inert` when content is shown to allow interaction
          cardContentPlaceholder.removeAttribute('inert');
          cardWrapper.dataset.contentLoaded = 'true';
        }
      }
    });

    // Remove content and class on mouse leave
    cardWrapper.addEventListener('mouseleave', function() {
      if (cardWrapper.dataset.contentLoaded === 'true') {
        var card = cardContentPlaceholder.querySelector('.card');
        if (card) {
          card.classList.remove('visible');
          // Remove the content after transition and reset `inert`
          setTimeout(function() {
            cardContentPlaceholder.innerHTML = '';
            cardWrapper.dataset.contentLoaded = 'false';
            cardContentPlaceholder.setAttribute('inert', '');
          }, 300);
        }
      }
    });
  });
});

// Function to close the card on mobile when the close icon is clicked
function showscloseCard(uniqueId) {
  var cardWrapper = document.querySelector(`.show-profile-wrapper[data-show-id="${uniqueId}"]`);
  
  if (cardWrapper) {
    var cardContentPlaceholder = cardWrapper.querySelector('.card-content-placeholder');
    if (cardContentPlaceholder) {
      var card = cardContentPlaceholder.querySelector('.card');
      
      if (card) {
        card.classList.remove('visible');
        setTimeout(function() {
          cardContentPlaceholder.innerHTML = '';
          cardWrapper.dataset.contentLoaded = 'false';
          cardContentPlaceholder.setAttribute('inert', '');
        }, 300);
      }
    }
  }
}
